import { BaseItem } from '../baseitem';
import { BaseDTO } from '../basedto';

export class ProposalLocation extends BaseDTO {
  FullName: string = '';
  Country: BaseItem = { Id: 0, Description: 'N/A' };
  State: BaseItem = { Id: 0, Description: 'N/A' };
  City: BaseItem = { Id: 0, Description: 'N/A' };

  CityId: number = 0;
  CityName: string = 'N/A';
  StateId: number = 0;
  StateName: string = 'N/A';
  CountryId: number = 0;
  CountryName: string = 'N/A';

  constructor() {
    super();
    this.refresh();
  }

  refresh(): void {
    this.Country = { Id: this.CountryId, Description: this.CountryName };
    this.State = { Id: this.StateId, Description: this.StateName };
    this.City = { Id: this.CityId, Description: this.CityName };
    const parts = [this.City.Description, this.State.Description, this.Country.Description]
      .map((part) => part || 'N/A')
      .filter((part) => part !== 'N/A');
    this.FullName = parts.length ? parts.join(', ') : '';
  }

  isManual(): boolean {
    return !this.CityId || this.CityId === 0;
  }

  isEmpty(): boolean {
    return (!this.CityName && !this.StateName && !this.CountryName) || (this.CityName === 'N/A' && this.StateName === 'N/A' && this.CountryName === 'N/A');
  }

  toString(): string {
    this.refresh();
    return this.FullName;
  }
}
